module.exports = "../fonts/Futura-Medium.woff";


//////////////////
// WEBPACK FOOTER
// ./@fonts/futura/Futura-Medium.woff
// module id = 514
// module chunks = 7